module.exports = "/_next/static/images/game-1-intro-tutorial-suspect3-7a75f5090c94536d4780c0a82fecba1e.jpg";